import { render, staticRenderFns } from "./GlobeIcon.vue?vue&type=template&id=a8b09808"
import script from "./GlobeIcon.vue?vue&type=script&lang=js"
export * from "./GlobeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports